export { default } from './password-rules';
